import {ComponentProps, useCallback, useContext, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Divider, Typography} from '@mui/material';

import {CompanyModuleRow} from './CompanyModuleRow';
import {BasicTable, TableColumn} from '../../../components/BasicTable/BasicTable';
import {createBasicTableColumn} from '../../../components/BasicTable/createBasicTableColumn';
import {CompanyContext} from '../../../contexts/CompanyContext/CompanyContext';
import {CompanyModule} from '../../../types/CompanyProductConfiguration/CompanyModule';

export const CompanyModulesTable = () => {
  const {productConfiguration} = useContext(CompanyContext);
  const {t} = useTranslation('translation', {keyPrefix: 'companySettings.modulesTable'});

  const createColumns = useCallback((): TableColumn[] => {
    return [
      createBasicTableColumn('name', t('name'), {
        maxWidth: 'fit-content',
      }),
      createBasicTableColumn('details', t('details'), {
        maxWidth: 'fit-content',
      }),
    ];
  }, [t]);

  const rowData = useMemo(() => {
    const companyModules = productConfiguration.data?.companyModules;

    if (!companyModules) return [];

    return companyModules
      .filter((module: CompanyModule) => module.enabled)
      .sort((a: CompanyModule, b: CompanyModule) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
      .map((module: CompanyModule) => ({
        module,
        id: module.resourceId,
      }));
  }, [productConfiguration.data?.companyModules]);

  return (
    <>
      <Typography variant='h3'>{t('title')}</Typography>
      <Typography variant='body1' gutterBottom>
        {t('subtitle')}
      </Typography>
      <Divider
        sx={{
          width: '100%',
          marginBottom: '16px',
        }}
      />
      <BasicTable<ComponentProps<typeof CompanyModuleRow>>
        columns={createColumns()}
        Row={CompanyModuleRow}
        rowData={rowData || []}
      />
    </>
  );
};
